import React from 'react';
import { Link } from 'react-router-dom';
import { trackButtonClick } from '../../utils/analytics';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import ArticleCard from '../ArticleCard/ArticleCard';
import CategoryCard from '../CategoryCard/CategoryCard';
import NewsletterSignup from '../NewsletterSignup/NewsletterSignup';
import articles from '../Articles/articles';
import categories from '../Categories/categories';
import '../Styles/layout.css';
import '../Styles/utils.css';
import '../Styles/reset.css';


function Home() {
    const featuredArticles = articles.slice(0, 3);
    const recentArticles = articles.slice(3, 6);

    return (
        <div>
            <SEO
                title="SmartLifeChoice - Your Journey to Health & Fitness"
                description="Evidence-based health and fitness articles, expert advice, and practical tips to help you achieve your wellness goals. Explore nutrition, workouts, mental health, and lifestyle guidance."
                url="/home"
                type="website"
            />
            <Header />

            <section className="hero">
                <div className="hero-content">
                    <h1>Your Journey to Health & Fitness</h1>
                    <p>
                        Evidence-based articles, expert advice, and practical tips to help you
                        achieve your health and fitness goals.
                    </p>
                    <a href="#featured" className="btn btn-accent" onClick={() => trackButtonClick('Discover Articles', 'Hero')}>Discover Articles</a>
                </div>
            </section>

            <main className="main">
                <div className="container">
                    <section id="featured" className="featured-section">
                        <h2 className="section-title">Featured Articles</h2>
                        <div className="featured-grid">
                            {featuredArticles.map((article) => (
                                <ArticleCard key={article.id} article={article} />
                            ))}
                        </div>
                    </section>

                    <section className="categories-section">
                        <h2 className="section-title">Explore Categories</h2>
                        <div className="categories-grid">
                            {categories.map((category) => (
                                <CategoryCard key={category.id} category={category} />
                            ))}
                        </div>
                    </section>

                    <section className="featured-section">
                        <h2 className="section-title">Recent Articles</h2>
                        <div className="featured-grid">
                            {recentArticles.map((article) => (
                                <ArticleCard key={article.id} article={article} />
                            ))}
                        </div>
                        <div className="text-center mt-4">
                            <Link to="/articles" className="btn btn-outline" onClick={() => trackButtonClick('View All Articles', 'Home')}>View All Articles</Link>
                        </div>
                    </section>
                </div>

                <NewsletterSignup />
            </main>

            <Footer />
        </div>
    );
}

export default Home;
